import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import PropTypes from 'prop-types';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import { Link } from 'react-router-dom';
import { TOP_LEVEL_ROUTES } from '../../scripts/routes';

const ResourceGroupCard = ({ resourceGroupData }) => {
	const { imageUrl, displayName, pageId } = resourceGroupData;

	return (
		<Card>
			<CardActionArea
				component={Link}
				to={`/${TOP_LEVEL_ROUTES.resources}/${pageId}`}
			>
				<CardMedia
					image={imageUrl}
					title={displayName}
					sx={{ height: 181 }}
				/>
				<CardContent sx={{ height: 126 }}>
					<Typography variant='h5'>{displayName}</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

ResourceGroupCard.propTypes = {
	resourceGroupData: PropTypes.object.isRequired,
};

export default ResourceGroupCard;
